var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hour-grouping-cell text-center"},[_c('div',{staticClass:"hour text-lg"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,"h")))]),_c('div',{staticClass:"meridiem"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,"A")))])])}
var staticRenderFns = []

export { render, staticRenderFns }